import { render, staticRenderFns } from "./ReviewDependentsView.vue?vue&type=template&id=20b07a08&"
import script from "./ReviewDependentsView.vue?vue&type=script&lang=js&"
export * from "./ReviewDependentsView.vue?vue&type=script&lang=js&"
import style0 from "./ReviewDependentsView.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports